import AdministrationHome from '@/view/administration/Administration';
// Tables de référence
import ParametreEnum from '@/view/administration/ParametreEnum';
// Personne morale
import PersonneMoraleList from '@/view/administration/PersonneMoraleList';
import PersonneMoraleDetail from '@/view/administration/PersonneMoraleDetail';
import ContexteList from '@/view/administration/ContexteList';
import ContexteDetail from '@/view/administration/ContexteDetail';
import Cotisables from '@/view/administration/Cotisables';
// Profils
import AutorisationAgil from '@/view/administration/AutorisationAgil';
//RGPD
import ContactExpire from '@/view/administration/ContactExpire';
import AlerteValidite from '@/view/administration/AlerteValidite';
import DonneesRGPD from '@/view/administration/DonneesRGPD';
//Mail
import MailList from '@/view/administration/MailList';
import MailHistorique from '@/view/administration/MailHistorique';
import Mail from '@/view/administration/Mail';
//Corbeille
import Corbeille from '@/view/administration/Corbeille';

// Liens externes
import DetailPersonneMorale from '@/view/personnemorale/DetailPersonneMorale';
import DetailPersonnePhysique from '@/view/personnephysique/DetailPersonnePhysique';
import DetailInstance from '@/view/instance/DetailInstance';

const ADMINISTRATION_BREADCRUMB = {
  code: 'administration.title',
  link: {
    name: 'administration/home',
  },
};

const ADMINISTRATION_TABLESREFERENCE_BREADCRUMB = {
  code: 'administration.tablesReference.title',
  link: {
    name: 'administration/home',
    params: {
      tab: 'tablesReference',
    },
  },
};

const ADMINISTRATION_PERSONNEMORALE_BREADCRUMB = {
  code: 'administration.personneMorale.title',
  link: {
    name: 'administration/home',
    params: {
      tab: 'personneMorale',
    },
  },
};
const ADMINISTRATION_PERSONNEMORALE_LIST_BREADCRUMB = {
  code: 'administration.personneMorale.personneMorale.list.title',
  link: {
    name: 'administration/personneMorale/personnesMorales',
  },
};

const ADMINISTRATION_CONTEXTES_LIST_BREADCRUMB = {
  code: 'administration.personneMorale.contextes.list.title',
  link: {
    name: 'administration/personneMorale/contextes',
  },
};

const ADMINISTRATION_PROFILS_BREADCRUMB = {
  code: 'administration.profils.title',
  link: {
    name: 'administration/home',
    params: {
      tab: 'profils',
    },
  },
};

const ADMINISTRATION_RGPD_BREADCRUMB = {
  code: 'administration.rgpd.title',
  link: {
    name: 'administration/home',
    params: {
      tab: 'rgpd',
    },
  },
};

const ADMINISTRATION_MAIL_BREADCRUMB = {
  code: 'administration.mails.liste.title',
  link: {
    name: 'administration/mails/liste',
  },
};

const ADMINISTRATION_CORBEILLE_BREADCRUMB = {
  code: 'administration.corbeille.title',
  link: {
    name: 'administration/home',
    params: {
      tab: 'corbeille',
    },
  },
};

export default [
  /*
   * La page d'accueil du menu paramétrage
   */
  {
    path: '/administration/home',
    name: 'administration/home',
    component: AdministrationHome,
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION)',
      breadcrumb: () => [ADMINISTRATION_BREADCRUMB],
    },
    children: [
      {
        path: ':tab',
        component: AdministrationHome,
        meta: {
          auth: 'hasRole(PRIV_ADMINISTRATION)',
          breadcrumb: () => [ADMINISTRATION_BREADCRUMB],
        },
      },
    ],
  },
  /*
   * Tables de référence
   */
  {
    path: '/administration/tablesReference/pays',
    name: 'administration/tablesReference/pays',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.pays.title',
      api: {
        url: 'administration/parametre-enum',
        enumType: 'pays',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      restrictions: {
        codeUpdatable: true,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.pays.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/region',
    name: 'administration/tablesReference/region',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.region.title',
      api: {
        url: 'administration/parametre-enum',
        enumType: 'region',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      restrictions: {
        codeUpdatable: true,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.region.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/departement',
    name: 'administration/tablesReference/departement',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.departement.title',
      api: {
        url: 'administration/parametre-enum',
        writeUrl: 'administration/parametre-enum-departement',
        enumType: 'departement',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      extraFields: [
        {
          name: 'region',
          enumNamespace: 'region',
          type: 'enum',
          editionMode: 'standard',
          viewInList: true,
        },
      ],
      restrictions: {
        codeUpdatable: true,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.departement.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/ville',
    name: 'administration/tablesReference/ville',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.ville.title',
      api: {
        url: 'administration/parametre-enum',
        writeUrl: 'administration/parametre-enum-ville',
        enumType: 'ville',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      extraFields: [
        {
          name: 'codePostal',
          type: 'text',
          editionMode: 'standard',
          viewInList: true,
        },
      ],
      restrictions: {
        codeUpdatable: true,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.ville.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/typeAccesAgil',
    name: 'administration/tablesReference/typeAccesAgil',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.typeAccesAgil.title',
      api: {
        url: 'administration/parametre-enum',
        writeUrl: 'administration/parametre-enum-type-acces-agil',
        enumType: 'typeAccesAgil',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      extraFields: [
        {
          name: 'description',
          type: 'text',
          editionMode: 'standard',
        },
      ],
      restrictions: {
        codeUpdatable: true,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_PROFILS_BREADCRUMB,
        {
          code: 'administration.tablesReference.typeAccesAgil.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/privilegeAgil',
    name: 'administration/tablesReference/privilegeAgil',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.privilegeAgil.title',
      api: {
        url: 'administration/parametre-enum',
        writeUrl: 'administration/parametre-enum-privilege-agil',
        enumType: 'privilegeAgil',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      extraFields: [
        {
          name: 'description',
          type: 'text',
          editionMode: 'standard',
        },
      ],
      restrictions: {
        create: false,
        delete: false,
        update: false,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_PROFILS_BREADCRUMB,
        {
          code: 'administration.tablesReference.privilegeAgil.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/typeAcces',
    name: 'administration/tablesReference/typeAcces',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.typeAcces.title',
      api: {
        url: 'administration/parametre-enum',
        writeUrl: 'administration/parametre-enum-type-acces',
        enumType: 'typeAcces',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      extraFields: [
        {
          name: 'description',
          type: 'text',
          editionMode: 'standard',
        },
      ],
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.typeAcces.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/domaineActivite',
    name: 'administration/tablesReference/domaineActivite',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.domaineActivite.title',
      api: {
        url: 'administration/parametre-enum',
        enumType: 'domaineActivite',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      restrictions: {
        codeUpdatable: true,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.domaineActivite.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/secteurActivite',
    name: 'administration/tablesReference/secteurActivite',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.secteurActivite.title',
      api: {
        url: 'administration/parametre-enum',
        enumType: 'secteurActivite',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      restrictions: {
        codeUpdatable: true,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.secteurActivite.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/civilite',
    name: 'administration/tablesReference/civilite',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.civilite.title',
      api: {
        url: 'administration/parametre-enum',
        enumType: 'civilite',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.civilite.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/fonctionContact',
    name: 'administration/tablesReference/fonctionContact',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.fonctionContact.title',
      api: {
        url: 'administration/parametre-enum',
        enumType: 'fonctionContact',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      restrictions: {
        codeUpdatable: true,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.fonctionContact.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/typeContact',
    name: 'administration/tablesReference/typeContact',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.typeContact.title',
      api: {
        url: 'administration/parametre-enum',
        enumType: 'typeContact',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      restrictions: {
        codeUpdatable: true,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.typeContact.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/typeDivision',
    name: 'administration/tablesReference/typeDivision',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.typeDivision.title',
      api: {
        url: 'administration/parametre-enum',
        enumType: 'typeDivision',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      restrictions: {
        codeUpdatable: true,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.typeDivision.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/typeInstance',
    name: 'administration/tablesReference/typeInstance',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.typeInstance.title',
      api: {
        url: 'administration/parametre-enum',
        enumType: 'typeInstance',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      restrictions: {
        codeUpdatable: true,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.typeInstance.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/typeLait',
    name: 'administration/tablesReference/typeLait',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.typeLait.title',
      api: {
        url: 'administration/parametre-enum',
        enumType: 'typeLait',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      restrictions: {
        codeUpdatable: true,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.typeLait.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/typeParticipant',
    name: 'administration/tablesReference/typeParticipant',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.typeParticipant.title',
      api: {
        url: 'administration/parametre-enum',
        enumType: 'typeParticipant',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      restrictions: {
        codeUpdatable: true,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.typeParticipant.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/typePersonneMorale',
    name: 'administration/tablesReference/typePersonneMorale',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.typePersonneMorale.title',
      api: {
        url: 'administration/parametre-enum',
        enumType: 'typePersonneMorale',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      restrictions: {
        codeUpdatable: true,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.typePersonneMorale.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/demandeType',
    name: 'administration/tablesReference/demandeType',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.demandeType.title',
      api: {
        url: 'administration/parametre-enum',
        enumType: 'demandeType',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      restrictions: {
        create: false,
        update: true,
        delete: false,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.demandeType.title',
        },
      ],
    },
  },
  {
    path: '/administration/tablesReference/demandeStatus',
    name: 'administration/tablesReference/demandeStatus',
    component: ParametreEnum,
    props: {
      title: 'administration.tablesReference.demandeStatus.title',
      api: {
        url: 'administration/parametre-enum',
        enumType: 'demandeStatus',
      },
      returnRoute: ADMINISTRATION_TABLESREFERENCE_BREADCRUMB.link,
      restrictions: {
        create: false,
        update: true,
        delete: false,
      },
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_REFERENCE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_TABLESREFERENCE_BREADCRUMB,
        {
          code: 'administration.tablesReference.demandeStatus.title',
        },
      ],
    },
  },
  /*
   * Personnes morales et divisions, contextes, cotisables
   */
  {
    path: '/administration/personneMorale/personnesMorales',
    name: 'administration/personneMorale/personnesMorales',
    component: PersonneMoraleList,
    props: {
      title: 'administration.personneMorale.personneMorale.list.title',
      returnRoute: ADMINISTRATION_PERSONNEMORALE_BREADCRUMB.link,
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_PERSONNEMORALE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_PERSONNEMORALE_BREADCRUMB,
        { code: 'administration.personneMorale.personneMorale.list.title' },
      ],
    },
  },
  {
    path: '/administration/personneMorale/personneMorale/:id',
    name: 'administration/personneMorale/personneMorale-detail',
    component: PersonneMoraleDetail,
    props: {
      title: 'administration.personneMorale.personneMorale.detail.title',
      returnRoute: ADMINISTRATION_PERSONNEMORALE_LIST_BREADCRUMB.link,
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_PERSONNEMORALE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_PERSONNEMORALE_BREADCRUMB,
        ADMINISTRATION_PERSONNEMORALE_LIST_BREADCRUMB,
        { code: 'administration.personneMorale.personneMorale.detail.title' },
      ],
    },
  },
  {
    path: '/administration/personneMorale/contextes',
    name: 'administration/personneMorale/contextes',
    component: ContexteList,
    props: {
      title: 'administration.personneMorale.contextes.list.title',
      returnRoute: ADMINISTRATION_PERSONNEMORALE_BREADCRUMB.link,
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_CONTEXTES)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_PERSONNEMORALE_BREADCRUMB,
        { code: 'administration.personneMorale.contextes.list.title' },
      ],
    },
  },
  {
    path: '/administration/personneMorale/contexte-new',
    name: 'administration/personneMorale/contexte-new',
    component: ContexteDetail,
    props: {
      title: 'administration.personneMorale.contextes.detail.title',
      returnRoute: ADMINISTRATION_CONTEXTES_LIST_BREADCRUMB.link,
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_CONTEXTES)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_PERSONNEMORALE_BREADCRUMB,
        ADMINISTRATION_CONTEXTES_LIST_BREADCRUMB,
        { code: 'administration.personneMorale.contextes.detail.title' },
      ],
    },
  },
  {
    path: '/administration/personneMorale/contexte/:id',
    name: 'administration/personneMorale/contexte-detail',
    component: ContexteDetail,
    props: {
      title: 'administration.personneMorale.contextes.detail.title',
      returnRoute: ADMINISTRATION_CONTEXTES_LIST_BREADCRUMB.link,
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_CONTEXTES)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_PERSONNEMORALE_BREADCRUMB,
        ADMINISTRATION_CONTEXTES_LIST_BREADCRUMB,
        { code: 'administration.personneMorale.contextes.detail.title' },
      ],
    },
  },
  /*
   * Cotisables
   */
  {
    path: '/administration/personneMorale/cotisable',
    name: 'administration/personneMorale/cotisable',
    component: Cotisables,
    props: {
      title: 'administration.personneMorale.cotisable.title',
      returnRoute: ADMINISTRATION_PERSONNEMORALE_BREADCRUMB.link,
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_PERSONNEMORALE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_PERSONNEMORALE_BREADCRUMB,
        {
          code: 'administration.personneMorale.cotisable.title',
        },
      ],
    },
  },
  /*
   * Profils
   */
  {
    path: '/administration/profils/autorisationAgil',
    name: 'administration/profils/autorisationAgil',
    component: AutorisationAgil,
    props: {
      title: 'administration.profils.authorisationAgil.title',
      returnRoute: ADMINISTRATION_PROFILS_BREADCRUMB.link,
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_PROFILS)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_PROFILS_BREADCRUMB,
        {
          code: 'administration.profils.autorisationAgil.title',
        },
      ],
    },
  },
  /*
   * RGPD
   */
  {
    path: '/administration/rgpd/contacts',
    name: 'administration/rgpd/contacts',
    component: ContactExpire,
    props: {
      title: 'administration.rgpd.contacts.title',
      api: {
        url: 'administration/contacts-expires',
      },
      returnRoute: ADMINISTRATION_RGPD_BREADCRUMB.link,
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_RGPD)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_RGPD_BREADCRUMB,
        {
          code: 'administration.rgpd.contacts.title',
        },
      ],
    },
  },
  {
    path: '/administration/rgpd/alerteValidite',
    name: 'administration/rgpd/alerteValidite',
    component: AlerteValidite,
    props: {
      title: 'administration.rgpd.alerteValidite.title',
      api: {
        url: 'administration/alerte-validite',
      },
      returnRoute: ADMINISTRATION_RGPD_BREADCRUMB.link,
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_RGPD)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_RGPD_BREADCRUMB,
        {
          code: 'administration.rgpd.alerteValidite.title',
        },
      ],
    },
  },
  {
    path: '/administration/rgpd/donneesRGPD',
    name: 'administration/rgpd/donneesRGPD',
    component: DonneesRGPD,
    props: {
      title: 'administration.rgpd.donneesRGPD.title',
      api: {
        url: 'administration/donneesRGPD',
      },
      returnRoute: ADMINISTRATION_RGPD_BREADCRUMB.link,
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_RGPD)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_RGPD_BREADCRUMB,
        {
          code: 'administration.rgpd.donneesRGPD.title',
        },
      ],
    },
  },
  /*
   * Mails
   */
  {
    path: '/administration/mails/detail/:id',
    name: 'administration/mails/detail',
    component: Mail,
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_MAILS)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_MAIL_BREADCRUMB,
        { code: 'administration.mails.detail.title' },
      ],
    },
  },
  {
    path: '/administration/mails/liste',
    name: 'administration/mails/liste',
    component: MailList,
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_MAILS)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        { code: 'administration.mails.liste.title' },
      ],
    },
  },
  {
    path: '/administration/mails/historique',
    name: 'administration/mails/historique',
    component: MailHistorique,
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_MAILS)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        { code: 'administration.mails.historique.title' },
      ],
    },
  },

  /*
   * Corbeille
   */
  {
    path: '/administration/corbeille/corbeille',
    name: 'administration/corbeille/corbeille',
    component: Corbeille,
    props: {
      api: {
        url: 'administration/corbeille',
      },
      returnRoute: ADMINISTRATION_BREADCRUMB.link,
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_CORBEILLE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_CORBEILLE_BREADCRUMB,
      ],
    },
  },
  {
    path: '/administration/corbeille/personne-physique/:id',
    name: 'administration/corbeille/personne-physique/detail',
    component: DetailPersonnePhysique,
    props: {
      enModeReactivation: true,
      enModeCreation: false,
      deleted: true,
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_CORBEILLE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_CORBEILLE_BREADCRUMB,
        { code: 'personnePhysique.detail.title' },
      ],
    },
  },
  {
    path: '/administration/corbeille/personne-morale/:id',
    name: 'administration/corbeille/personne-morale/detail',
    component: DetailPersonneMorale,
    props: {
      enModeReactivation: true,
      enModeCreation: false,
      deleted: true,
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_CORBEILLE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_CORBEILLE_BREADCRUMB,
        { code: 'personneMorale.detail.title.default' },
      ],
    },
  },
  {
    path: '/administration/corbeille/instance/:id',
    name: 'administration/corbeille/instance/detail',
    component: DetailInstance,
    props: {
      enModeReactivation: true,
      enModeCreation: false,
      deleted: true,
    },
    meta: {
      auth: 'hasRole(PRIV_ADMINISTRATION_CORBEILLE)',
      breadcrumb: () => [
        ADMINISTRATION_BREADCRUMB,
        ADMINISTRATION_CORBEILLE_BREADCRUMB,
        { code: 'instance.detail.title' },
      ],
    },
  },
];
